// react-table depends on spreading props; we could name them explicitly but this component might
// break if the shape of the return value from getHeaderGroupProps() changes
/* eslint-disable react/jsx-props-no-spreading */
// react-table is extending from object, so we have to do that as well
/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { ColumnInstance, HeaderGroup, TableHeaderProps } from 'react-table';

interface TableHeaderGroupProps<D extends object> {
    headerGroup: HeaderGroup<D>;
}

/**
 * A component that renders a group of headers with a border and right padding (to work with
 * scrollbars).
 * @param props - {@link TableHeaderGroupProps}
 */
export function TableHeaderGroup<D extends object>({
    headerGroup,
}: TableHeaderGroupProps<D>): JSX.Element {
    const headerGroupProps = headerGroup.getHeaderGroupProps();

    return (
        <div {...headerGroupProps} className="tr header-group">
            {headerGroup.headers.map(
                (column: ColumnInstance<D>): JSX.Element => {
                    let headerProps: TableHeaderProps = { key: '' };

                    if (column.getSortByToggleProps) {
                        headerProps = column.getHeaderProps(
                            column.getSortByToggleProps(),
                        );
                    } else {
                        headerProps = column.getHeaderProps();
                    }

                    const { key: headerKey, ...headerRest } = headerProps;

                    return (
                        <div
                            key={headerKey}
                            {...headerRest}
                            className="th respond-to-mouse"
                        >
                            {column.render('Header')}
                        </div>
                    );
                },
            )}
        </div>
    );
}
